import _ from "lodash";
import BaseDecorator from "./BaseDecorator";

import st from "lib/utils/index";

export default class ProductScheduleDecorator extends BaseDecorator {
  constructor(data) {
    super(data);

    this.start_dates_assignation_type = this.start_dates_assignation_type;
    this.start_times_assignation_type = this.start_times_assignation_type;
    // if (!st.authorize.company.reseller) {
    //   // this.normalize();
    // }
  }

  normalize() {
    if (
      this.start_dates_assignation_type === "recursion" &&
      this.start_date_recursion_from &&
      this.start_date_recursion_to &&
      this.start_date_recursion_wdays
    ) {
      this.calculateStartDatesFromRecursion();
    }

    if (
      this.start_times_assignation_type === "recursion" &&
      this.start_time_recursion_from &&
      this.start_time_recursion_to &&
      this.start_time_recursion_step
    ) {
      this.calculateStartTimesFromRecursion();
    }

    this.start_dates = _(this.start_dates)
      .uniq()
      .sortBy((d) => moment.tz(d, moment.RUBY_DATE_FORMAT, this.time_zone_name).valueOf())
      .value();

    this.start_times = _(this.start_times)
      .uniq()
      .sortBy((d) => moment.tz(d, moment.TIME_FORMAT, this.time_zone_name).valueOf())
      .value();
  }

  calculateStartDatesFromRecursion() {
    const lastDate = moment.tz(this.start_date_recursion_to, moment.RUBY_DATE_FORMAT, this.time_zone_name);
    this.start_dates = [];
    for (
      let date = moment.tz(this.start_date_recursion_from, moment.RUBY_DATE_FORMAT, this.time_zone_name);
      date.isSameOrBefore(lastDate, "days");
      date.add(1, "days").startOf("day")
    ) {
      this.start_date_recursion_wdays.includes(+date.format("d")) &&
        this.start_dates.push(date.format(moment.RUBY_DATE_FORMAT));
    }
    return this.start_dates;
  }

  calculateStartTimesFromRecursion() {
    const lastDate = moment.tz(this.start_time_recursion_to, moment.TIME_FORMAT, this.time_zone_name);
    this.start_times = [];
    for (
      let time = moment.tz(this.start_time_recursion_from, moment.TIME_FORMAT, this.time_zone_name);
      time.isSameOrBefore(lastDate, "seconds");
      time.add(this.start_time_recursion_step, "seconds")
    ) {
      this.start_times.push(time.format(moment.TIME_FORMAT));
    }
    return this.start_times;
  }

  get start_date_recursion_range() {
    return [this.start_date_recursion_from, this.start_date_recursion_to];
  }

  set start_date_recursion_range([startDate, endDate]) {
    this.start_date_recursion_from = startDate;
    this.start_date_recursion_to = endDate;
  }

  get start_dates_assignation_type() {
    return this._start_dates_assignation_type !== undefined
      ? this._start_dates_assignation_type
      : this.guess_start_dates_assignation_type();
  }
  guess_start_dates_assignation_type() {
    return this.start_date_recursion_from ? "recursion" : this.start_dates.length > 1 ? "normal" : null;
  }
  set start_dates_assignation_type(v) {
    this._start_dates_assignation_type = v || null;
  }

  get start_times_assignation_type() {
    return this._start_times_assignation_type !== undefined
      ? this._start_times_assignation_type
      : this.guess_start_times_assignation_type();
  }
  guess_start_times_assignation_type() {
    return this.start_time_recursion_from ? "recursion" : this.start_times.length > 1 ? "normal" : null;
  }
  set start_times_assignation_type(v) {
    this._start_times_assignation_type = v || null;
  }

  get includes_time() {
    return this.start_times.length > 0;
  }

  get recursion_attributes() {
    return {
      start_dates: this.start_dates,
      start_date_recursion_from:
        this.start_dates_assignation_type === "recursion" ? this.start_date_recursion_from : undefined,
      start_date_recursion_to:
        this.start_dates_assignation_type === "recursion" ? this.start_date_recursion_to : undefined,
      start_date_recursion_wdays:
        this.start_dates_assignation_type === "recursion" ? this.start_date_recursion_wdays : undefined,
      start_times: this.start_times,
      start_time_recursion_from:
        this.start_times_assignation_type === "recursion" ? this.start_time_recursion_from : undefined,
      start_time_recursion_to:
        this.start_times_assignation_type === "recursion" ? this.start_time_recursion_to : undefined,
      start_time_recursion_step:
        this.start_times_assignation_type === "recursion" ? this.start_time_recursion_step : undefined,
      // time_duration: this.time_duration,
    };
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/ProductScheduleDecorator.js